import React from 'react';
import { Box, List, ListItemText, Divider, Tooltip, ListItemIcon, Drawer as MuiDrawer, ListItemButton } from '@mui/material';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import LogoutIcon from '@mui/icons-material/Logout';

interface DrawerProps {
  isOpen: boolean;
  onClose: () => void;
}

const Drawer: React.FC<DrawerProps> = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const { signOut } = useAuth();

  const handleNavigate = (path: string) => {
    navigate(path);
    onClose();
  };

  const handleSignOut = () => {
    signOut();
    navigate('/login');
  };

  return (
    <MuiDrawer anchor="left" open={isOpen} onClose={onClose}>
      <Box sx={{ width: 250 }} role="presentation" onClick={onClose} onKeyDown={onClose}>
        <List>
          <Tooltip title="Gerenciar perfil e informações da conta." placement="right">
            <ListItemButton onClick={() => handleNavigate('/perfil')}>
              <ListItemIcon>
                <AccountCircle color="primary" />
              </ListItemIcon>
              <ListItemText primary="Perfil" />
            </ListItemButton>
          </Tooltip>
          <Divider />
          <Tooltip title="Desconectar sua conta Publisol." placement="right">
            <ListItemButton onClick={handleSignOut}>
              <ListItemIcon>
                <LogoutIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary="Desconectar" />
            </ListItemButton>
          </Tooltip>
        </List>
      </Box>
    </MuiDrawer>
  );
};

export default Drawer;